import Tag from '../../../../../ui/icons/Tag/Tag';
import Button from '../../../../../ui/Button/BlockButton';
import { useTheme } from '../../../../../../hooks/useTheme';
import { SponsoredPill } from './SponsoredPill';
import styles from '../Disco.module.css';

interface CoverInlineProps {
  offerCount: number;
  onInvoke: () => void;
}

export function CoverInline({ offerCount, onInvoke }: CoverInlineProps) {
  const theme = useTheme();

  return (
    <div
      className={styles.coverInline}
      style={{
        ...theme.panelcontainerNoneNone,
        height: 'auto',
      }}
    >
      <div
        className={styles.coverInlineContent}
        style={{
          ...theme.panelbodyNoneNone,
        }}
      >
        <div className={styles.coverInlineLeft}>
          <div className={styles.coverInlineIcon}>
            <Tag
              s={{
                color: theme.iconsPrimaryNone?.color,
                width: 24,
                height: 24,
              }}
            />
          </div>
          <div>
            <div
              className={styles.coverInlineText}
              style={{
                ...theme.headersMediumNone,
                textTransform: 'none',
              }}
            >
              {offerCount} offers matched to your order <SponsoredPill />
            </div>
            <div
              className={styles.coverInlineSubtext}
              style={theme.bodytextDefaultNone}
            >
              Available for a limited time.
            </div>
          </div>
        </div>
        <div className={styles.coverInlineRight}>
          <Button onClick={onInvoke}>VIEW OFFERS</Button>
        </div>
      </div>
    </div>
  );
}
